import { gql } from '@efficiently/client-core-graphql-models';

export const ARCHIVE_CONTENTS = gql(`
	mutation ArchiveContents($ids: [String!]!) {
		archiveContents(ids: $ids)
	}
`);
